import { render, staticRenderFns } from "./TcodePie.vue?vue&type=template&id=2234ee6d&"
import script from "./TcodePie.vue?vue&type=script&lang=js&"
export * from "./TcodePie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports